import moment from 'moment'
export const packageLevelCode = [
  { id: -1, text: '', value: '_BLANK_' },
  { id: 1, text: 'Inner', value: '1' },
  { id: 2, text: 'Intermediate', value: '2' },
  { id: 3, text: 'Outer', value: '3' },
  { id: 4, text: 'No Packaging Hierarchy', value: '4' },
];

export const defaultValueUom = 'W_Kilogram';
export const defaultpackageLevelCode = '4';
export const defaultPackageUom = 'Package_Box';
export const defaultQty = 'UC_Each';
export const convertDateToUTC = (value) => {
  return value
    ? new Date(
        new Date(Number(value)).getUTCMonth() +
          1 +
          '/' +
          new Date(Number(value)).getUTCDate() +
          '/' +
          new Date(Number(value)).getUTCFullYear()
      ).getTime()
    : -999;
};
export const convertDateToUTCEpoch = (value) => {
  let output = -999
  if (value && !isNaN(value.getTime())) {
    output = moment(value)
    output.set({hours: 0, minutes: 0, seconds: 0, milliseconds: 0});
    output = output.valueOf();
  }
  return output;
};


export const convertDateToUTCEpoch1 = (value) => {
  let output = -999
  if (value && !isNaN(value.getTime())) {
    output = Date.UTC(new Date(value).getFullYear(),new Date(value).getMonth(),new Date(value).getDate())
  }
  return output;
};